module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "majors-list"
  }, [_c('div', {
    staticClass: "majors-toggle-archived banner"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "academic-period-display"
  }, [_c('div', {
    staticClass: "period-label"
  }, [_vm._v("Academic Year")]), _vm._v(" "), (!_vm.showArchived) ? _c('h2', [_vm._v(_vm._s(_vm.currentPeriod.academic_year))]) : _vm._e(), _vm._v(" "), (_vm.showArchived) ? _c('h2', [_vm._v("All Academic Years")]) : _vm._e()]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "hollow",
    on: {
      "click": _vm.toggleArchived
    }
  }, [_vm._v("\n          " + _vm._s(_vm.showArchived ? "Hide Previous Years" : "Show Previous Years") + "\n        ")])])]), _vm._v(" "), (!_vm.showArchived) ? _c('p', {
    staticClass: "info"
  }, [_vm._v("Listing degrees for the current academic year (" + _vm._s(_vm.currentPeriod.academic_year) + "). If you do not see the plan you are looking for, you may toggle archived years using the button to the right.")]) : _vm._e(), _vm._v(" "), (_vm.showArchived) ? _c('p', {
    staticClass: "info"
  }, [_vm._v("Listing degrees for the all academic years. Use the dropdowns to view a a plan for a specific year.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "headerPlaceholder",
    staticClass: "listing-header-placeholder",
    class: {
      "header-fixed": _vm.headerFixed
    }
  }), _vm._v(" "), (!_vm.showArchived) ? _c('div', {
    ref: "header",
    staticClass: "listing-header",
    class: {
      "header-fixed": _vm.headerFixed,
      "is-unm": _vm.$store.getters.isUnmMain
    }
  }, [_vm._m(0)]) : _c('div', {
    ref: "header",
    staticClass: "listing-header",
    class: {
      "header-fixed": _vm.headerFixed,
      "is-unm": _vm.$store.getters.isUnmMain
    }
  }, [_vm._m(1)]), _vm._v(" "), _vm._l((_vm.nestedMajors), function(college) {
    return _c('college', {
      key: college.key,
      attrs: {
        "college": college
      }
    })
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unit-content"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "unit-name"
  }, [_c('span', [_vm._v("Level")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-level"
  }, [_c('span', [_vm._v("Degree")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-availabitlity"
  }, [_c('span', [_vm._v("Online")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-plans"
  }, [_c('span', [_vm._v("Plan")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-credits"
  }, [_c('span', [_vm._v("Credits")])]), _vm._v(" "), _c('div', {
    staticClass: "header-button"
  }, [_c('span', [_vm._v("Information")])]), _vm._v(" "), _c('div', {
    staticClass: "header-button"
  }, [_c('span', [_vm._v("Degree Plan")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unit-content"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "unit-name"
  }, [_c('span', [_vm._v("Level")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-level"
  }, [_c('span', [_vm._v("Degree")])]), _vm._v(" "), _c('div', {
    staticClass: "header-button"
  }, [_c('span', [_vm._v("Academic Period")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37074028","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/major_list.vue
// module id = 1122
// module chunks = 1